import { ApiRole } from '../api-types/role.api';
import { Role } from '../app-types/role.app';

/**
 * Transforms an API role object to an application role object.
 * @param input The API role object to transform.
 * @returns The transformed application role object.
 */
export function transformApiRoleToAppRole(input: ApiRole): Role {
	return {
		id: input.id,
		shortName: input.shortName,
		description: input.description,
		isActive: input.isActive,
	};
}

/**
 * Transforms an array of API role objects to an array of application role objects.
 * @param inputs The array of API role objects to transform.
 * @returns The array of transformed application role objects.
 */
export function transformApiRolesToAppRoles(inputs: ApiRole[]): Role[] {
	return inputs.map(transformApiRoleToAppRole);
}
